export default __webpack_public_path__ + "static/klein-kompakt-platzsparend_boge-industriekompressoren-9bdb3c8ec0680ffd4ef4d8325ec051d0.jpeg";